module.exports = __webpack_public_path__ + "static/media/gb-wls.2d554424.svg";